var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-item-container",on:{"click":function($event){return _vm.handClick(_vm.contactItem.url)}}},[_c('Img',{attrs:{"width":_vm.width,"url":_vm.contactItem.item +'.png'}}),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.contactItem.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }